import { defineMessages } from 'react-intl';
import { takeLatest, call, put, delay } from 'redux-saga/effects';
import { isMessage } from 'helpers/intl-fns';
import { reportError } from 'helpers/error-logging';
import { showSnackbar, hideSnackbar } from './Snackbar.reducer';

export const SNACKBAR_DISPLAY_LENGTH = 5000;

export const CREATE_SNACKBAR = 'CREATE_SNACKBAR';

const createSnackbar = (message, values, { type, icon, isLowStyle, skipIntl } = {}, description = null) => ({
  type: CREATE_SNACKBAR,
  payload: {
    message,
    values,
    type,
    icon,
    isLowStyle,
    skipIntl,
    description,
  },
});

// Snackbars expect intl messages.  If, for some reason, a string makes it this far
// we log it in Datadog RUM and pass the string through to the Snackbar as-is.
const messages = defineMessages({
  errorPassthrough: {
    id: 'snackbar.error-passthrough',
    defaultMessage: 'Error: {msg}',
  },
  successPassthrough: {
    id: 'snackbar:success-passthrough',
    defaultMessage: 'Success: {msg}',
  },
});

export const createSuccessSnackbar = (message, values = {}, { isLowStyle = false } = {}, description = null) =>
  createSnackbar(message, values, { type: 'success', isLowStyle }, description);

export const createErrorSnackbar = (
  message,
  values = {},
  { icon = null, isLowStyle = false, skipIntl = false } = {},
  description = null
) => {
  return createSnackbar(message, values, { type: 'error', icon, isLowStyle, skipIntl }, description);
};

export function* showThenHideSnackbar({ payload }) {
  const { message, type, values: { duration } = {}, skipIntl } = payload;
  if (isMessage(message) || skipIntl) {
    yield put(showSnackbar(payload));
  } else {
    yield call(reportError, `Snackbars only support intl messages - received string = "${message}"`);
    yield put(
      showSnackbar({
        ...payload,
        message: type === 'success' ? messages.successPassthrough : messages.errorPassthrough,
        values: { msg: message },
      })
    );
  }
  yield delay(duration || SNACKBAR_DISPLAY_LENGTH);
  yield put(hideSnackbar());
}

export function* watchSnackbar() {
  yield takeLatest(CREATE_SNACKBAR, showThenHideSnackbar);
}
